import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import PaymentClaimList from "./PaymentClaimList";
import Upload from "./Upload";
import ProjectSubHeader from "../components/ProjectSubHeader";
// import Workinprogrees from "../../../components/Workinprogrees";

const tabsKey = {
  list: 1,
  input: 2,
};

const PaymnetClaims = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("tab") || "list";
  const defaultActiveKey = tabsKey[selectedTab];
  const [activeTab, setActiveTab] = useState(
    parseInt(defaultActiveKey) === 1 ? "List" : "Input New"
  );

  useEffect(() => {
    setActiveTab(parseInt(defaultActiveKey) === 1 ? "List" : "Input New");
  }, [defaultActiveKey]);

  return (
    <>
      <div className="cms-page">
        {/* <Workinprogrees /> */}
        <div className="page-content-block">
          <div className="full-content-block">
            <ProjectSubHeader title={"Payment Claims"} />
            <div className="content-details">
              <div className="table-top-btn">
                <ul
                  className="nav nav-tabs"
                  onClick={(event) => {
                    setActiveTab(event?.target?.innerText);
                  }}
                >
                  <li className={activeTab === "List" ? "active" : ""}>
                    <Link key={1}>List</Link>
                  </li>
                  <li className={activeTab === "Input New" ? "active" : ""}>
                    <Link key={2}>Input New</Link>
                  </li>
                </ul>
              </div>
              <div className="custom-table tab-table">
                {activeTab === "List" && <PaymentClaimList />}
                {activeTab === "Input New" && <Upload />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PaymnetClaims;
